import { IConsultantSuiviCommentaireRequestModel } from "./core/_models"
import { Form, Formik, FormikHelpers } from "formik"
import { toast } from "react-toastify"
import * as Yup from "yup"
import { AxiosError } from "axios"
import { IConsultantModel, IHttpErrorResponseModel } from "@common-models/*"
import { CONST_HTTP_CUSTOM_CODE_FORM_VALIDATION_ERROR } from "@common-constants/*"
import MyAlert from "@common-utils/MyAlert"
import MySimpleSpinner from "@common-utils/MySimpleSpinner"
import React from "react"
import { consultantSuiviCommentaireRequest } from "./core/_requests"
import MyTextareaField from "@common-utils/fields/MyTextareaField"

const ConsultantSuiviCommentaire = ({ consultant, onSubmitCallback = () => {}, annulerCallback = () => {} }: IPropsModel) => {
     // Form schema
     const schema = Yup.object().shape({
          commentaire: Yup.string().required().label(`"Commentaire"`),
     })

     // Init values
     const initialValues: IConsultantSuiviCommentaireRequestModel = {}

     // Handle submit
     function handleSubmit(values: IConsultantSuiviCommentaireRequestModel, helpers: FormikHelpers<IConsultantSuiviCommentaireRequestModel>) {
          helpers.setStatus(null)

          consultantSuiviCommentaireRequest(consultant.id as number, values)
               .then(r => {
                    toast.success("Le commentaire a bien été ajouté.", { autoClose: 5000 })
                    onSubmitCallback()
               })
               .catch((e: AxiosError) => {
                    const error: IHttpErrorResponseModel = e.response?.data

                    // Set form errors
                    if (error?.code === CONST_HTTP_CUSTOM_CODE_FORM_VALIDATION_ERROR && error?.errors) {
                         for (const key in error.errors) helpers.setFieldError(key, error.errors[key])
                    }

                    // Set form global status and notify user using a toast
                    helpers.setStatus(error?.detail)
                    toast.error(error?.detail, { autoClose: false })

                    // Stop submit loader
                    helpers.setSubmitting(false)
               })
     }

     return (
          <>
               <Formik initialValues={initialValues} validationSchema={schema} onSubmit={handleSubmit}>
                    {helpers => {
                         return (
                              <Form noValidate autoComplete="off">
                                   {helpers.status && (
                                        <MyAlert type={"danger"} classNames={"mb-4"}>
                                             {helpers.status}
                                        </MyAlert>
                                   )}

                                   {/* Commentaire */}
                                   <div className="row mb-4">
                                        <label className="col-lg-4 col-form-label fw-bold fs-6 required">Commentaire</label>

                                        <div className="col-lg-8">
                                             <MyTextareaField
                                                  name={"commentaire"}
                                                  value={helpers.values.commentaire}
                                                  isInvalid={!!helpers.errors.commentaire}
                                                  onChange={val => helpers.setFieldValue("commentaire", val)}
                                                  placeholder={"Commentaire"}
                                                  autoFocus
                                             />
                                             {helpers.errors.commentaire && <div className={"text-danger"}>{helpers.errors.commentaire}</div>}
                                        </div>
                                   </div>

                                   {/* Submit button */}
                                   <div className={"d-flex justify-content-end"}>
                                        <button
                                             className={"btn btn-sm btn-outline btn-outline-primary d-inline-flex align-items-center me-2"}
                                             type={"button"}
                                             onClick={annulerCallback}
                                             disabled={helpers.isSubmitting}
                                        >
                                             Annuler
                                        </button>
                                        <button className={"btn btn-sm btn-primary d-inline-flex align-items-center"} type={"submit"} disabled={helpers.isSubmitting}>
                                             {!helpers.isSubmitting ? <>Valider</> : <MySimpleSpinner size={"sm"} />}
                                        </button>
                                   </div>
                              </Form>
                         )
                    }}
               </Formik>
          </>
     )
}

interface IPropsModel {
     consultant: IConsultantModel
     onSubmitCallback?: () => void
     annulerCallback?: () => void
}

export default ConsultantSuiviCommentaire
